import { Admin } from "models/admin";
import { doGet, doPatch } from "../request";

export const adminDoGetProfile = async () => {
  const admin = await doGet<Admin>(`/admin/profile`);
  return admin;
};

interface PasswordChangeProps {
  oldPassword: string;
  newPassword: string;
  newPasswordAgain: string;
}

export const adminDoPatchProfile = async (
  data: Partial<Admin> | PasswordChangeProps,
) => {
  const admin = await doPatch<Admin>(`/admin/profile`, data);
  return admin;
};
